export type SnoozePreset = 'in-1h' | 'in-4h' | 'tomorrow' | 'next-week';

/** Resolves a snooze preset to an absolute ISO timestamp. */
export function snoozeUntilIso(preset: SnoozePreset, from: Date = new Date()): string {
  const date = new Date(from);
  switch (preset) {
    case 'in-1h':
      date.setHours(date.getHours() + 1);
      break;
    case 'in-4h':
      date.setHours(date.getHours() + 4);
      break;
    case 'tomorrow':
      date.setDate(date.getDate() + 1);
      date.setHours(9, 0, 0, 0);
      break;
    case 'next-week':
      date.setDate(date.getDate() + 7);
      date.setHours(9, 0, 0, 0);
      break;
  }
  return date.toISOString();
}
